import HttpClient from "../../lib/HttpClient";

interface MessageCountResponse {
  status: {
    success: boolean;
  };
  count: number;
}

export const getNewMessagesCountFromServer = async (
  userId: string
): Promise<MessageCountResponse | undefined> => {
  const MESSAGE_COUNT_URL = `/api/v1/chat/channel/${userId}/unread/count`;

  try {
    const response = await HttpClient.performGet<MessageCountResponse>(
      MESSAGE_COUNT_URL
    );
    const data: MessageCountResponse = response?.body;
    return data;
  } catch (err) {}
};
